import {cssTheme} from '../theme'
import {css} from '../theme/css'

function overlayWhiteBg(color: string) {
  try {
    // @ts-expect-error если что-то не так, падаем при сборке и так
    const [r, g, b, a] = Array.from(color.match(/[\d.]*\d/g)).map(parseFloat) as [number, number, number, number]

    return `#${[r, g, b].map(color => Math.round(color * a + 255 * (1 - a)).toString(16)).join('')}`
  } catch {
    throw new Error(`Trying to overlay non-rgba color: ${color}. Need color in format "rgba(0,0,0,0.5)".`)
  }
}

export const fullWidth = css`
  width: 100%;
  width: -moz-available;
  width: -webkit-fill-available;
`

export const linkButton = css`
  color: ${cssTheme.default.day.controlText} !important;
`

/** так как в GWC кнопки по умолчанию теперь полупрозрачные, они ломаются когда находятся не на белом фоне. Дизайн у нас
 * это не учитывает, так что делаем их руками непрозрачными */
export const defaultNonTransparent = css`
  ${cssTheme.default.day.controlMinor.token}: ${overlayWhiteBg(cssTheme.default.day.controlMinor.hex)};
  ${cssTheme.components.buttons.default.bgColorHovered.token}: ${overlayWhiteBg(
    cssTheme.components.buttons.default.bgColorHovered.hex,
  )};
  ${cssTheme.components.buttons.default.bgColorPressed.token}: ${overlayWhiteBg(
    cssTheme.components.buttons.default.bgColorPressed.hex,
  )};
`

// Хексы - cssTheme.default.day.error, на который наложили 5% и 10% черного цвета соответственно. Когда пытаюсь делать это программно - стили ломаются, делаю сейчас так чтобы закрыть до отпуска
// TODO - сделать нормально
export const error = css`
  ${cssTheme.default.day.controlMinorText.token}: ${cssTheme.default.day.textInvert};
  ${cssTheme.components.buttons.ghost.bgColor.token}: ${cssTheme.default.day.error};
  ${cssTheme.components.buttons.ghost.bgColorHovered.token}: #ed3a29;
  ${cssTheme.components.buttons.ghost.bgColorPressed.token}: #e13727
`

// тупо копирую класс для отображения загрузки из компонента кнопки
// по дефолту GWC его не экспортирует
export const loadingClassName = css`
  @keyframes loadingEffect {
    0% {
      transform: translateX(-100%);
    }
    100% {
      transform: translateX(100%);
    }
  }

  position: relative;
  pointer-events: none;

  &:after {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    animation: loadingEffect 2s infinite;
    display: block;
    content: '';
    background: ${cssTheme.components.buttons.loadingGradient};
  }
`
